<script setup lang="ts"></script>

<template>
  <div class="page-header">
    <div id="page-header-content-target" class="container">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page-header {
  position: fixed;
  top: v.$pc-header-height;
  left: 0;
  z-index: 40;
  width: 100vw;
  border-bottom: 1px solid v.$basic-blue;
  background-color: v.$basic-white;

  @include m.sp_mode {
    width: 100%;
    top: v.$sp-header-height;
  }

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    max-width: 119.4rem;
    margin: auto;
    padding: 1rem 3.2rem 1.5rem;

    @include m.sp_mode {
      min-width: v.$sp-min-width;
      max-width: v.$sp-max-width;
      height: v.$sp-page-header-height;
      padding: 1rem 1.3rem 1.5rem;
    }
  }
}
</style>
